import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UpdateIndicatorComponent } from './update-indicator.component';
import { CustomButtonsModule } from '../buttons/custom-buttons.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  exports: [UpdateIndicatorComponent],
  declarations: [UpdateIndicatorComponent],
  providers: [],
  imports: [CommonModule, CustomButtonsModule, MatIconModule],
})
export class UpdateIndicatorModule {}
